import { render, staticRenderFns } from "./ForgotPasswordForm.vue?vue&type=template&id=7f548c0c&scoped=true"
import script from "./ForgotPasswordForm.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordForm.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordForm.vue?vue&type=style&index=0&id=7f548c0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f548c0c",
  null
  
)

export default component.exports